/** Dev-only diagnostics; production stays quiet unless `error`. */
const dev = import.meta.env.DEV;

export const logger = {
  debug(...args: unknown[]): void {
    if (dev) {
      console.log(...args);
    }
  },
  warnDev(...args: unknown[]): void {
    if (dev) {
      console.warn(...args);
    }
  },
  warn(...args: unknown[]): void {
    console.warn(...args);
  },
  error(...args: unknown[]): void {
    console.error(...args);
  },
};
